import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "rounded-md space-y-3" }
const _hoisted_2 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between py-2" }
const _hoisted_3 = {
  key: 0,
  class: "bg-yellow-100 border border-yellow-400 text-yellow-700 px-3 py-2 rounded relative text-sm",
  role: "alert"
}
const _hoisted_4 = { class: "block sm:inline" }
const _hoisted_5 = {
  key: 1,
  class: "bg-red-100 border border-red-400 text-red-700 px-3 py-2 rounded relative text-sm",
  role: "alert"
}
const _hoisted_6 = { class: "block sm:inline" }
const _hoisted_7 = { class: "pt-2" }
const _hoisted_8 = {
  key: 2,
  class: "text-center text-sm text-red-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_FormCheckbox = _resolveComponent("FormCheckbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FormButton = _resolveComponent("FormButton")!

  return (_openBlock(), _createElementBlock("form", {
    class: "space-y-4",
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_FormInput, {
        id: "email-address",
        name: "email",
        type: "email",
        label: "Email adresa",
        modelValue: _ctx.formData.email,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.email) = $event)),
        placeholder: "Email adresa",
        required: "",
        error: _ctx.errors.email,
        inputClass: ""
      }, null, 8, ["modelValue", "error"]),
      _createVNode(_component_FormInput, {
        id: "password",
        name: "password",
        type: "password",
        label: "Lozinka",
        modelValue: _ctx.formData.password,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.password) = $event)),
        placeholder: "Lozinka",
        required: "",
        error: _ctx.errors.password,
        inputClass: ""
      }, null, 8, ["modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FormCheckbox, {
        id: "remember-me",
        name: "remember-me",
        modelValue: _ctx.formData.rememberMe,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.rememberMe) = $event))
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createElementVNode("span", { class: "text-sm" }, "Zapamti me", -1)
        ])),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_router_link, {
        to: "/forgot-password",
        class: "text-sm font-medium text-indigo-400 hover:text-indigo-300 mt-2 sm:mt-0 text-right"
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode(" Zaboravili ste lozinku? ")
        ])),
        _: 1
      })
    ]),
    (_ctx.rateLimitWarning)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.rateLimitWarning), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.serverError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.serverError), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_FormButton, {
        loading: _ctx.loading,
        disabled: _ctx.loginBlocked,
        class: "w-full"
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode(" Prijavi se ")
        ])),
        _: 1
      }, 8, ["loading", "disabled"])
    ]),
    (_ctx.cooldownActive)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Previše pokušaja prijave. Pokušajte ponovo za " + _toDisplayString(_ctx.cooldownTimeRemaining) + " sekundi. ", 1))
      : _createCommentVNode("", true)
  ], 32))
}